import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, DadosEmissaoCINState } from './types';

export const INITIAL_STATE: DadosEmissaoCINState = {
	data: null,
	status: 0,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): DadosEmissaoCINState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.DADOS_EMISSAO_CIN_REQUEST: {
				break;
			}
			case Types.DADOS_EMISSAO_CIN_SUCCESS: {
				draft.data = action.payload;
				draft.status = 200;
				break;
			}

			case Types.DADOS_EMISSAO_CIN_FAILURE: {
				draft.data = INITIAL_STATE.data;
				draft.status = 400;
				break;
			}

			case Types.DADOS_EMISSAO_CIN_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}

			default:
		}
		return draft;
	});
}
